import { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';
import s from './EmbeddedVideo.module.css';

import { EmbeddedVideoProps } from '../../types/components/video';

const EmbeddedVideo = ({
    src,
    autoPlay,
    controls,
    muted,
}: EmbeddedVideoProps) => {
    const [hasWindow, setHasWindow] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => setHasWindow(true), 0);
        }
    }, []);

    if (!hasWindow) {
        // Returns null on first render, so the client and server match
        return null;
    }

    return (
        <div className={s.EmbeddedVideo} data-testid="embedded-video">
            {src && hasWindow ? (
                <ReactPlayer
                    src={src}
                    width="100%"
                    height="100%"
                    controls={controls}
                    muted={muted}
                    loop={true}
                    playing={autoPlay === true ? true : false}
                />
            ) : null}
        </div>
    );
};

export default EmbeddedVideo;
